// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2UserGetUsersWithSiteAccountGetUsersWithSiteAccountResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2UserGetUsersWithSiteAccountGetUsersWithSiteAccountResponse.attributeTypeMap;
    }
}
AuthenticationV2UserGetUsersWithSiteAccountGetUsersWithSiteAccountResponse.discriminator = undefined;
AuthenticationV2UserGetUsersWithSiteAccountGetUsersWithSiteAccountResponse.additionalProperties = false;
AuthenticationV2UserGetUsersWithSiteAccountGetUsersWithSiteAccountResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=authenticationV2UserGetUsersWithSiteAccountGetUsersWithSiteAccountResponse.js.map